import L from "leaflet";

/** Leaflet lat/lng bounds → pixel ROI at native slide zoom (metadata only). */
export function leafletBoundsToPixelRoi(map, bounds, maxZoom) {
  if (!map || !bounds || maxZoom == null) {
    return { x: 0, y: 0, width: 0, height: 0 };
  }
  const nw = map.project(bounds.getNorthWest(), maxZoom);
  const se = map.project(bounds.getSouthEast(), maxZoom);
  const x = Math.min(nw.x, se.x);
  const y = Math.min(nw.y, se.y);
  const width = Math.abs(se.x - nw.x);
  const height = Math.abs(se.y - nw.y);
  return {
    x: Math.round(x),
    y: Math.round(y),
    width: Math.round(width),
    height: Math.round(height),
  };
}

/** Pixel ROI at the current map zoom — sent to backend for server-side tile compositing. */
export function capturePixelsFromBounds(map, bounds) {
  if (!map || !bounds) {
    return { capture_zoom: 0, capture_pixels: { x: 0, y: 0, width: 0, height: 0 } };
  }
  const zoom = map.getZoom();
  const nw = map.project(bounds.getNorthWest(), zoom);
  const se = map.project(bounds.getSouthEast(), zoom);
  return {
    capture_zoom: zoom,
    capture_pixels: {
      x: Math.min(nw.x, se.x),
      y: Math.min(nw.y, se.y),
      width: Math.max(1, Math.round(Math.abs(se.x - nw.x))),
      height: Math.max(1, Math.round(Math.abs(se.y - nw.y))),
    },
  };
}

export function boundsToJson(bounds) {
  if (!bounds) return null;
  return {
    southWest: {
      lat: bounds.getSouthWest().lat,
      lng: bounds.getSouthWest().lng,
    },
    northEast: {
      lat: bounds.getNorthEast().lat,
      lng: bounds.getNorthEast().lng,
    },
  };
}

export function boundsFromJson(json) {
  let data = json;
  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch (_) {
      return null;
    }
  }
  if (!data?.southWest || !data?.northEast) return null;
  return L.latLngBounds(
    [data.southWest.lat, data.southWest.lng],
    [data.northEast.lat, data.northEast.lng]
  );
}

export function slideMaxNativeZoom(geoJson) {
  const z = geoJson?.max_zoom;
  return typeof z === "number" && z >= 0 ? z : null;
}
